import { render } from "./campaigns.vue?vue&type=template&id=2ce1a866&scoped=true"
import script from "./campaigns.vue?vue&type=script&lang=js"
export * from "./campaigns.vue?vue&type=script&lang=js"

import "./campaigns.vue?vue&type=style&index=0&id=2ce1a866&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce1a866"]])

export default __exports__